import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'secretPut',
    method: 'PUT',
  });
  useEffect(() => {
    if (param) {
      exec({ url: `/api/users/secret/key/${param.id}`, data: param })
      // exec({
      //   url: '/api/users/secret/key?id=' + param.id + '&inspect_type='
      //     + param.inspect_type + '&is_enabled=' + param.is_enabled,
      //   data: param
      // })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return [isRequestSuccessed, exec];
});